import { render } from "./contact.vue?vue&type=template&id=dac46666"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jmallach/Dev/jicub/vuejs-bosb-microsite/my-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__